import RGB from './RGB.js';

var HSL = {
  toRGB: function toRGB(_ref) {
    var h = _ref.h,
      s = _ref.s,
      l = _ref.l;
    var red, green, blue;
    var saturation = s / 100;
    var lightness = l / 100;
    if (saturation === 0) {
      red = green = blue = l; // achromatic
      return {
        r: red,
        g: green,
        b: blue
      };
    } else {
      var c = (1 - Math.abs(2 * lightness - 1)) * saturation;
      var x = c * (1 - Math.abs(h / 60 % 2 - 1));
      var m = lightness - c / 2,
        _red = 0,
        _green = 0,
        _blue = 0;
      if (0 <= h && h < 60) {
        _red = c;
        _green = x;
        _blue = 0;
      } else if (60 <= h && h < 120) {
        _red = x;
        _green = c;
        _blue = 0;
      } else if (120 <= h && h < 180) {
        _red = 0;
        _green = c;
        _blue = x;
      } else if (180 <= h && h < 240) {
        _red = 0;
        _green = x;
        _blue = c;
      } else if (240 <= h && h < 300) {
        _red = x;
        _green = 0;
        _blue = c;
      } else if (300 <= h && h < 360) {
        _red = c;
        _green = 0;
        _blue = x;
      }
      _red = Math.round((_red + m) * 255);
      _green = Math.round((_green + m) * 255);
      _blue = Math.round((_blue + m) * 255);
      return {
        r: _red,
        g: _green,
        b: _blue
      };
    }
  },
  toHEX: function toHEX(hsl) {
    return RGB.toHEX(HSL.toRGB(hsl));
  },
  saturate: function saturate(hsl, amount) {
    if (amount === void 0) {
      amount = 10;
    }
    hsl.s += amount;
    hsl.s = Math.min(100, Math.max(0, hsl.s));
    return hsl;
  },
  desaturate: function desaturate(hsl, amount) {
    if (amount === void 0) {
      amount = 10;
    }
    hsl.s -= amount;
    hsl.s = Math.min(100, Math.max(0, hsl.s));
    return hsl;
  },
  darken: function darken(hsl, amount) {
    if (amount === void 0) {
      amount = 10;
    }
    hsl.l -= amount;
    hsl.l = Math.min(100, Math.max(0, hsl.l));
    return hsl;
  },
  lighten: function lighten(hsl, amount) {
    if (amount === void 0) {
      amount = 10;
    }
    hsl.l += amount;
    hsl.l = Math.min(100, Math.max(0, hsl.l));
    return hsl;
  }
};

export { HSL as default };
//# sourceMappingURL=HSL.js.map
